import { defineStore } from 'pinia'

import * as accessoryFormApi from '../services/api/accessory-form'
import { IApproval } from './staff'

export interface IAccessoryData {
  name: string
  quantity?: number
  unit?: string
  price?: number
  total?: number
}

export interface IAccessoryFormData {
  id: number
  status: string
  note: string
  reason: string
  approvals: Array<IApproval>
  received_at: string
  accessories: Array<IAccessoryData>
  assignee_id: number
  assessor_id: number
  car_id: number
  customer_id: number
  assignee: any
  car: any
  customer: any
  created_at: string
}

export const useAccessoryFormStore = defineStore('AccessoryForm', {
  state: () => ({
    isLoading: true,
    accessoryForm: {
      id: 0,
      status: '',
      note: '',
      reason: '',
      approvals: [],
      received_at: '',
      accessories: [],
      assignee_id: 0,
      assessor_id: 0,
      car_id: 0,
      customer_id: 0,
      assignee: {},
      car: {},
      customer: {},
      created_at: '',
    } as IAccessoryFormData,
    accessoryForms: [] as IAccessoryFormData[],
    count: 0,
  }),
  actions: {
    setAccessoryForm(data: IAccessoryFormData) {
      this.accessoryForm = data
    },
    setAccessoryForms(data: IAccessoryFormData[]) {
      this.accessoryForms = data
    },
    setCount(data: number) {
      this.count = data
    },
    setLoading(value: boolean) {
      this.isLoading = value
    },
    addAccessoryForm(data: IAccessoryFormData) {
      this.accessoryForms.push(data)
    },
    async getAccessoryFormDetail(id: number) {
      try {
        const { data } = await accessoryFormApi.get(id)
        this.setAccessoryForm(data)
        return data
      } catch (e: unknown) {
        throw new Error(String(e))
      }
    },
    async updateAccessoryForm(payload: any) {
      try {
        const { data } = await accessoryFormApi.update(this.accessoryForm.id, payload)
        this.setAccessoryForm(data)
      } catch (e: unknown) {
        throw new Error(String(e))
      }
    },
    async applyAccessoryForm() {
      try {
        const { data } = await accessoryFormApi.apply(this.accessoryForm.id)
        this.setAccessoryForm(data)
      } catch (e: unknown) {
        throw new Error(String(e))
      }
    },
    async rejectAccessoryForm(payload: any) {
      try {
        const { data } = await accessoryFormApi.reject(this.accessoryForm.id, payload)
        this.setAccessoryForm(data)
      } catch (e: unknown) {
        throw new Error(String(e))
      }
    },
    async remakeAccessoryForm(payload: any) {
      try {
        const { data } = await accessoryFormApi.remake(this.accessoryForm.id, payload)
        this.setAccessoryForm(data)
      } catch (e: unknown) {
        throw new Error(String(e))
      }
    },
    async approveAccessoryForm(payload: any) {
      try {
        const { data } = await accessoryFormApi.approve(this.accessoryForm.id, payload)
        this.setAccessoryForm(data)
      } catch (e: unknown) {
        throw new Error(String(e))
      }
    },
    async completeAccessoryForm(payload: any) {
      try {
        const { data } = await accessoryFormApi.complete(this.accessoryForm.id, payload)
        this.setAccessoryForm(data)
      } catch (e: unknown) {
        throw new Error(String(e))
      }
    },
    async countAccessoryForms() {
      try {
        const { data } = await accessoryFormApi.count()
        this.setCount(data)
      } catch (e: unknown) {
        throw new Error(String(e))
      }
    },
    async createAccessoryForm(payload: any) {
      try {
        const { data } = await accessoryFormApi.create(payload)
        this.addAccessoryForm(data)
        return data
      } catch (e: unknown) {
        throw new Error(String(e))
      }
    },
    async listAccessoryForms(params?: any) {
      try {
        this.setLoading(true)
        const result = await accessoryFormApi.list(params)
        const { data, total } = result as any
        this.setAccessoryForms(data)
        this.setLoading(false)
        return { data, total }
      } catch (e: unknown) {
        throw new Error(String(e))
      }
    },
    async listAllAccessoryForms(params?: any) {
      try {
        this.setLoading(true)
        const result = await accessoryFormApi.listAll(params)
        const { data, total } = result as any
        this.setAccessoryForms(data)
        this.setLoading(false)
        return { data, total }
      } catch (e: unknown) {
        throw new Error(String(e))
      }
    },
  },
})
